import { render, staticRenderFns } from "./CustomFormView.vue?vue&type=template&id=0534c370"
import script from "./CustomFormView.js?vue&type=script&lang=js&external"
export * from "./CustomFormView.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports